import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { BrandIconNowDelivery } from '@redteclab/brand-icons'
import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useNowGeneralContext } from '../../../../now'

export const ProductNowDeliveryBox: FC = () => {
  const { productPageNowDialogControls } = useNowGeneralContext()

  return (
    <div className="mb-3 w-full rounded-l bg-light-primary-low p-4">
      <div className="flex">
        <div>
          <div className="mr-2.5 flex size-12 items-center justify-center rounded-full bg-light-primary-low">
            <BrandIconNowDelivery className="size-12 fill-dark-brand" />
          </div>
        </div>
        <div className="flex flex-col items-start">
          <span className="text-s font-medium text-dark-primary-max">
            <FormattedMessage id="now.prompt.headline.deliverytimeAndAvailability" />
          </span>
          <span className="mt-1 text-xs text-dark-primary-strong">
            <FormattedMessage id="now.prompt.body.enterZipForAccurateDeliveryEstimations" />
          </span>
          <Button
            className="mt-2"
            data-qa-id="buybox-check-now"
            endIcon={<IconArrowRight />}
            onClick={productPageNowDialogControls.handleOpen}
            size="medium"
            variant="text"
          >
            <FormattedMessage id="now.prompt.link.checkAvailabilityNow" />
          </Button>
        </div>
      </div>
    </div>
  )
}
